import { Notes as NotesComponent } from '@components/Notes/Notes'

export const Notes = () => {
  return <NotesComponent />
}
